// extracted by mini-css-extract-plugin
export default {"actionsButton":"DishesActionsButton_actionsButton__T1OHM","placeHolderShimmer":"DishesActionsButton_placeHolderShimmer__Jc2We"};